<template>
  <div v-editable="blok" class="link">
    <a
      v-if="url && blok.externalLink"
      :href="url"
      :class="'link ' + modifierClass"
    >
      <span class="link__text" v-text="blok.text" />
    </a>
    <nuxt-link
      v-if="url && !blok.externalLink"
      :to="url"
      :class="'link ' + modifierClass"
      ><span class="link__text" v-text="blok.text"
    /></nuxt-link>
  </div>
</template>

<script>
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    modifierClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    url() {
      if (this.blok.link || this.blok.cached_url) {
        return this.blok.link ? this.blok.link.url : this.blok.link.cached_url
      }
      return false
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/scss/settings';

.link {
  display: inline;
}

.link--with-circle {
  display: inline-block;
  color: $white;
  margin: 5px 0 0 -10px;

  .link__text {
    display: inline-block;
    padding: 5px 0 0 0;
    transition: all 0.3s ease-in 0.1s;
  }

  .link__icon {
    opacity: 0;
    display: inline-block;
    background-color: $supernova;
    border-radius: 50%;
    padding: 2px 5px 2px;
    margin: 0;
    width: 0;
    height: 30px;
    text-align: center;
    vertical-align: middle;
    transform: scale(0) translateX(25px);
    transition: all 0.2s ease-in 0.2s;

    &::before {
      vertical-align: middle;
      line-height: 1em;
      color: $supernova;
      margin: 0;
      transition: color 0.5s;
    }
  }

  &:hover {
    .link__text {
      color: $supernova;
      padding-left: 10px;
      transition-delay: 0s;
      transition-timing-function: ease;
    }
    .link__icon {
      opacity: 1;
      transform: scale(1) translateX(0);
      width: 30px;
      margin-left: 10px;
      transition-delay: 0.1s;
      transition-timing-function: ease-out;
      transition-duration: 0.3s;

      &::before {
        color: $mine-shaft;
      }
    }
  }
}

@include media-breakpoint-up(md) {
  .link--with-circle {
    margin-left: -2px;
  }
}
</style>
